"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createSkipperTheme;
exports.Theme = void 0;

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _createMuiTheme = _interopRequireDefault(require("@material-ui/core/styles/createMuiTheme"));

var _createPalette = _interopRequireDefault(require("@sift/skipper/styles/createPalette"));

var _skipperDefaultTheme = _interopRequireDefault(require("@sift/skipper/styles/skipperDefaultTheme"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
} // removes a warning. this is just to resolve a TS thing


var Theme = undefined;
exports.Theme = Theme;

function createSkipperTheme() {
  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _createMuiTheme["default"])(_objectSpread(_objectSpread({}, (0, _deepmerge["default"])(_skipperDefaultTheme["default"], theme)), {}, {
    palette: (0, _createPalette["default"])(theme.palette || {})
  }));
}